import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';

@Component({
    selector: 'fi-customer-billing-customer-unit-edit-credit-card-information',
    templateUrl: './customer-billing-customer-unit-edit-credit-card-information.component.html',
    styleUrls: ['./customer-billing-customer-unit-edit-credit-card-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-unit-edit-credit-card-information' },
    standalone: false,
})
export class CustomerBillingCustomerUnitEditCreditCardInformationComponent implements OnInit {
    @Input() customer: CustomerBillingCustomerModel;
    billingReference: BillingContactModel;

    constructor() {}

    ngOnInit(): void {
        this.billingReference = this.customer.InvoiceInfo.BillingReference[0] || new BillingContactModel();
    }
}
